module.exports = __webpack_public_path__ + "static/media/icons-dropdown.9aa6d8bc.svg";